import $ from 'jquery'
import { Controller } from 'stimulus'

const STATE = {
  NO_FILES_CHOSEN: 0,
  DRAG_ACTIVE: 1,
  FILES_CHOSEN: 2,
}

export default class extends Controller {
  static targets = [
    'dropzone',
    'fileInput',
    'chosenFileTemplate',
    'chosenFiles',
    'progress',
    'progressBar',
    'error',

    'noFilesChosenState',
    'dragActiveState',
    'filesChosenState',
  ]
  static values = {
    allowedExtensions: Array,
    autoSubmit: Boolean,
    errorMessage: String,
  }

  chooseFile = (event) => {
    event.preventDefault()
    this.fileInputTarget.click()
  }

  // Can be called when a file is chosen from the file input or from drag and drop
  fileChosen = (event) => {
    event.preventDefault()
    const files = event.dataTransfer?.files || event.target.files
    if (Array.from(files).some((file) => !this.extensionAllowed(file))) {
      this.showError(this.errorMessageValue)
      return
    }
    this.hideError()
    this.fileInputTarget.files = files
    Array.from(files).forEach(this.addFile)
    this.activateState(STATE.FILES_CHOSEN)
    if (this.autoSubmitValue) this.submitForm()
  }

  handleDragOver = (event) => {
    event.preventDefault()
    this.activateState(STATE.DRAG_ACTIVE)
  }

  handleDragLeave = (event) => {
    event.preventDefault()
    this.activateState(
      this.fileInputTarget.files.length == 0
        ? STATE.NO_FILES_CHOSEN
        : STATE.FILES_CHOSEN
    )
  }

  /* Private */

  addFile = (file) => {
    this.chosenFilesTarget.innerHTML =
      this.chosenFileTemplateTarget.innerHTML.replace('$FILE_NAME$', file.name)

    // Preview images
    if (file.type.includes('image/')) {
      const src = URL.createObjectURL(file)

      $(this.chosenFilesTarget).append(
        $(
          `<img src="${src}" style="width: 100%; height: auto;" title="${file.name}" />`
        )
      )
    }
  }

  extensionAllowed(file) {
    if (this.allowedExtensionsValue.length == 0) return true
    const fileExtension = file.name.split('.').pop().toLowerCase()
    return this.allowedExtensionsValue.includes(fileExtension)
  }

  showError(message) {
    this.errorTarget.querySelector('.notice-box-title').innerText = message
    this.errorTarget.classList.remove('hidden')
  }

  hideError() {
    this.errorTarget.classList.add('hidden')
  }

  activateState(state) {
    $(this.noFilesChosenStateTarget).toggleClass(
      'invisible pointer-events-none',
      state != STATE.NO_FILES_CHOSEN
    )
    $(this.dragActiveStateTarget).toggleClass(
      'invisible',
      state != STATE.DRAG_ACTIVE
    )
    $(this.filesChosenStateTarget).toggleClass(
      'invisible pointer-events-none',
      state != STATE.FILES_CHOSEN
    )

    $(this.dropzoneTarget).toggleClass(
      'ring-inset ring-2 ring-primary-500 bg-primary-50 dark:bg-primary-900 !border-transparent',
      state == STATE.DRAG_ACTIVE
    )
  }

  submitForm = () => {
    const form = this.fileInputTarget.closest('form')
    $.sajax({
      url: form.action,
      type: form.method,
      data: new FormData(form),
      processData: false,
      contentType: false,
      xhr: () => {
        var xhr = $.ajaxSettings.xhr()
        xhr.upload.onprogress = (event) => {
          var percentComplete = (event.loaded / event.total) * 100
          this.setProgress(percentComplete)
        }
        return xhr
      },
    })
  }

  setProgress(progress) {
    this.progressTarget.classList.remove('hidden')
    this.progressBarTarget.style.setProperty(
      '--tw-translate-x',
      `-${100 - progress}%`
    )
    console.log('prog', progress)
  }
}
